import React from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { trans } from '../../localization/language';
import { opLogList, timestampToString } from '../../utils';

class Top3LoginHistory extends React.Component {
	componentDidMount() {
		opLogList();
	}
	
	handleViewMore() {
		browserHistory.push('/login-history');
	}
	
	renderTitle() {
		return (
			<div className="content-item__title oplog-title J-oplog-trigger">
				<div className="oplog-title__txt">
					{trans('login_history')}
				</div>
				<div className="oplog-title__icon"></div>
			</div>
		);
	}

	renderPanel() {
		return (
			<div className="oplog-panel">
				<div className="oplog-panel__txt">
					{trans('login_history_text')}
				</div>
				<a href="#" className="oplog-panel__link" onClick={this.handleViewMore.bind(this)}>{trans('view_more')}</a>
			</div>
		);
	}

	renderTableHead() {
		return (
			<div className="oplog-table__thead">
				<div className="oplog-table__row">
					<div className="oplog-table__th oplog-table__date">{trans('date_time')}</div>
					<div className="oplog-table__th oplog-table__country">{trans('country')}</div>
					<div className="oplog-table__th oplog-table__ip">IP</div>
					<div className="oplog-table__th oplog-table__opsrc">{trans('source')}</div>
				</div>
			</div>
		);
	}

	renderTableRow(date, country, ip, source,index){
		return (
			<div className="oplog-table__row oplog-table__tdrow" key={index}>
				<div className="oplog-table__td oplog-table__date">{date}</div>
				<div className="oplog-table__td oplog-table__country">{country}</div>
				<div className="oplog-table__td oplog-table__ip">{ip}</div>
				<div className="oplog-table__td oplog-table__opsrc">{source}</div>
			</div>
		);
	}

	renderTableBody() {
		var logs = [];
		for (var i = 0; i < Math.min(3, this.props.loginLog.length); ++i) {
			var log = this.props.loginLog[i];
			logs.push(this.renderTableRow(timestampToString(log.timestamp), log.country, log.ip, log.source, i));
		}
		return (
			<div className="oplog-table__tbody">
				{logs}
			</div>
		);
	}

	renderLogTable() {
		return (
			<div className="oplog-table">
				{this.renderTableHead()}
				{this.renderTableBody()}
			</div>
		);
	}
	
	renderListRow(date, country, ip, source,index) {
		return (
			<div className="oplog-list__row" key={index}>
				<div className="oplog-list__row-info">
					<div className="oplog-list__row-l">{date}</div>
					<div className="oplog-list__row-r">{source}</div>
				</div>
				<div className="oplog-list__row-location">{ip} {country?'('+country+')':''}</div>
			</div>
		);
	}
	
	renderLogList() {
		var logs = [];
		for (var i = 0; i < Math.min(3, this.props.loginLog.length); ++i) {
			var log = this.props.loginLog[i];
			logs.push(this.renderListRow(timestampToString(log.timestamp), log.country, log.ip, log.source, i));
		}
		return (
			<div className="oplog-list">
				{logs}
			</div>
		);
	}

	renderLogData() {
		return (
			<div className="oplog-data">
				{this.renderLogTable()}
				{this.renderLogList()}
			</div>
		);
	}
				
	renderViewMoreLink() {
		return (
			<a href="#" className="oplog-more" onClick={this.handleViewMore.bind(this)}>
				<div className="oplog-more__link">
					<div className="oplog-more__link-txt">{trans('view_more')}</div>
					<div className="oplog-more__link-icon"></div>
				</div>
			</a>
		);
	}

	renderMain() {
		return (
			<div className="oplog-wrap J-oplog-wrap">
				<div className="content-item__main J-oplog">
					<div className="oplog">
						{this.renderPanel()}
						{this.renderLogData()}
						{this.renderViewMoreLink()}
					</div>
				</div>
			</div>
		);
	}

	render() {
		return (
			<div className="content-item">
				{this.renderTitle()}
				{this.renderMain()}
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		userInfo: state.data.userInfo,
		loginLog: state.data.loginLog
	}
}

export default connect(mapStateToProps)(Top3LoginHistory);


// WEBPACK FOOTER //
// ./app/components/home/Top3LoginHistory.js